import React, {Component} from 'react';

export default class StoreManage extends Component{
    render(){

        return (
            <div>{this.props.children}</div>
        )
    }
}
